import React, {Component} from 'react'
import imagePrincipal from '../img/bglogin.jpg'
import { Link } from 'react-router-dom'
import IconGoogle from '../icons/IconGoogle'
import IconFacebook from '../icons/IconFacebook'
import 'firebase/firebase-auth'
import firebase from '../lib/Config'

class Login extends Component{
    _isMounted = false
    constructor(){
        super()
        this.state = {
            bgBanner: imagePrincipal
        }
    }
    updateDimensions() {
        if(window.innerWidth < 768) {
            if (this._isMounted) {
                this.setState({ 
                    
                })
                this.getImageLazy()
            }
        } else {
            let bgBanner = imagePrincipal
            if (this._isMounted) {
                this.setState({ 
                    bgBanner: bgBanner
                })
                this.getImageLazy()
            }
        }
    }
    getImageLazy(){
        let imgEl = document.getElementsByClassName('lazy');
        for (let i=0; i < imgEl.length; i++) {
            if(imgEl[i].getAttribute('data-src')) {
                imgEl[i].setAttribute('src',imgEl[i].getAttribute('data-src'));
                imgEl[i].removeAttribute('data-src');
            }
        }
    }
    componentDidMount() {
        this._isMounted = true;
        this.updateDimensions();
        window.addEventListener("resize", this.updateDimensions.bind(this));
    }
    componentWillUnmount() {
        this._isMounted = false;
        window.removeEventListener("resize", this.updateDimensions.bind(this));
    }
    handleAuth(){
        const provider = new firebase.auth.GoogleAuthProvider();
        firebase.auth().signInWithPopup(provider)
        .then(result => console.log(`${result.user.email} ha iniciado sesión`))
        .catch(error => console.log(`Error ${error.code}: ${error.message}`))
    }
    render(){
        return (
            <div className="login">
                <figure className="iron-image__container">
                    <img data-src={this.state.bgBanner}  className="lazy iron-image iron-image--fade-in" alt="Spring's Hotel" />
                </figure>
                <div className="login_wrap f f-ac f-jc">
                    <div className="gwr f f-ww">
                        <h1 className="login_title">Inicia Sesión</h1>
                        <form className="frm_login">
                            <div className="c-i">
                                <input type="text" placeholder="Nombre de Usuario o Email"/>
                            </div>
                            <div className="c-i f f-ww f-jcfe f-ac">
                                <input type="password" placeholder="Contraseña"/>
                                <div className="checkbox">
                                    <input type="checkbox" id="chk_remember"/>
                                    <label htmlFor="chk_remember">Recordar</label>
                                </div>
                                <button className="lostPassword">¿Olvidaste tu Contraseña?</button>
                            </div>
                            <div className="c-i">
                                <button className="btn btn-login">Ingresar</button>
                                <span>¿Aún no tienes una cuenta? <b><Link to={'/register'}>Regístrate</Link></b></span>
                            </div>
                        </form>
                        <p>o mediante</p>
                        <div className="w f f-jc">
                            <button className="btn btn-google" onClick={this.handleAuth}>
                                <IconGoogle color='#FFFFFF' height='16px' />
                            </button>
                            <button className="btn btn-facebook" onClick={this.handleAuth}>
                                <IconFacebook color='#FFFFFF' height='16px' />
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default Login;